import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import { addCompanyDocumentCategory, getAllCompanyDocumentCategories } from "../../../Services/CompanyDocumentManagement/CompanyDocumentCategoryService";
import CompanyDocumentCategoryForm
    from "../../../Components/Forms/Pages/CompanyDocument/CompanyDocumentCategory/CompanyDocumentCategoryForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const AddCompanyDocumentCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.companyDocument.companyDocumentCategory.addCompanyDocumentCategory.pageTitle);
    });

    useEffect(() => {
        fetch(); 
    },[])

    const fetch = () => {
        getAllCompanyDocumentCategories().then(response => {
            if (!response || !response.ok) {
                return;
            }
            setParents(response.data);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addCompanyDocumentCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <CompanyDocumentCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddCompanyDocumentCategory;